import { useCallback, useEffect } from 'react';
import { postMessageToParent } from '../../post-message/postMessageToParent';
import { VOICE_RECORDING_REQUEST } from '../../constants/PostMessageTypes';
import { useAppDispatch, useAppSelector } from '../../buildStore';
import { requestVoiceRecording, cancelVoiceRecording } from '../reducers/voiceInputSlice';
import { VOICE_INPUT_AWAITING_PERMISSION, VOICE_INPUT_RECORDING, VOICE_INPUT_TRANSCRIBING } from '../constants/voiceInputConstants';
const PERMISSION_TIMEOUT_MS = 10000;
export const useVoiceInput = () => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(state => state.voiceInput.status);
  const errorType = useAppSelector(state => state.voiceInput.errorType);

  // Reset if the host never responds (e.g. older embed without this handler)
  useEffect(() => {
    if (status !== VOICE_INPUT_AWAITING_PERMISSION) return;
    const id = setTimeout(() => dispatch(cancelVoiceRecording()), PERMISSION_TIMEOUT_MS);
    return () => clearTimeout(id);
  }, [status, dispatch]);
  const onStart = useCallback(() => {
    if (status === VOICE_INPUT_AWAITING_PERMISSION || status === VOICE_INPUT_RECORDING || status === VOICE_INPUT_TRANSCRIBING) return;
    dispatch(requestVoiceRecording());
    postMessageToParent(VOICE_RECORDING_REQUEST);
  }, [dispatch, status]);
  const onCancel = useCallback(() => {
    dispatch(cancelVoiceRecording());
  }, [dispatch]);
  return {
    status,
    errorType,
    onStart,
    onCancel
  };
};